const desktop = 900;
const mobile = 600;

export class ScreenSizes {
  desktop = desktop;
  tablet: number;
  mobile = mobile;

  public static screenSize() {
    const size = window.innerWidth;
    if (size <= mobile) return 'mobile';
    if (size > mobile && size < desktop) return 'tablet';
    return 'desktop';
  }
}
